import * as types from './users.types';

export const usersPageSelectors: types.IUsersPageSelectors = {
  selectActiveUserIds: (state) => state.page.users.activeUserIds,
  selectDeletedUserIds: (state) => state.page.users.deletedUserIds,
  selectIsFetched: (state) => state.page.users.isFetched,
  selectCreateUserSuccess: (state) => state.page.users.createUserSuccess,
  selectAddUserToTenantSuccess: (state) => state.page.users.addUserToTenantSuccess,
  selectUserExistenceCheck: (state) => state.page.users.userExistenceCheck,
};
